import { get, post } from '@/utils/apiBase.js';
// 矿工财富榜
const getMinerList = (option) => {
    return get('/apis/project/miner_score_rank', option)
}
// 领取矿工任务积分
export const postReceiveMinerCoins = (option) => {
    return post('/apis/project/cp/receive_miner_score', option);
};
// 挖矿分任务列表
const getMinerTaskList = (option) => {
    return get('/apis/project/cp/get_miner_task_list', option)
}
// 获取历史挖矿积分日期
const getMinerDateList = (option) => {
    return get('/apis/project/miner_rank_date', option)
}
export default {
    getMinerList,
    postReceiveMinerCoins,
    getMinerTaskList,
    getMinerDateList
};